import { Button, Grid, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

import emptyImage from '../../assets/images/empty.svg';

const EmptyState = ({ message, goToLink, goToText }) => {
  return (
    <>
      <Grid container direction='column' justifyContent='center' alignItems='center'>
        <Grid item xs={12}>
          <img src={emptyImage} alt='content not found' width='100px' height='auto' />
        </Grid>
        <Grid item xs={12} mt={2}>
          <Typography variant='h6' sx={{ color: '#616161' }}>
            {message}
          </Typography>
        </Grid>
        {goToLink && goToText && (
          <Grid item xs={12} mt={2}>
            <Button component={Link} to={goToLink}>
              {goToText}
            </Button>
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default EmptyState;
